import { useMemo } from 'react';

export default useMemo;
